import type {
    ValidationContext,
    ValidationResult,
    ValidationStrategy,
} from '../types'
import { isDuplicateArticle } from '../utils/validationHelpers'

/**
 * Creates a validation strategy for checking duplicate article names
 * @returns {ValidationStrategy} Validation strategy with validate method
 */
export const articleDuplicateValidator = (): ValidationStrategy => ({
    validate: (context: ValidationContext): ValidationResult => {
        const { text, textElement, isAddOperation, contentNodes } = context

        // For add operations, check against all nodes
        // For update operations, exclude the current node being edited
        const filteredNodes = isAddOperation
            ? contentNodes
            : contentNodes.filter((node) =>
                  node.elements?.every((e) => e.id !== textElement.id)
              )

        const isDuplicate = isDuplicateArticle(text, filteredNodes)

        return {
            isValid: !isDuplicate,
            errorMessage: isDuplicate
                ? `Duplicate Article: "${text}" already exists. Please choose a different name.`
                : undefined,
        }
    },
})
